import { render, staticRenderFns } from "./Shelf.vue?vue&type=template&id=d25a9f68&"
import script from "./Shelf.vue?vue&type=script&lang=js&"
export * from "./Shelf.vue?vue&type=script&lang=js&"
import style0 from "./Shelf.vue?vue&type=style&index=0&id=d25a9f68&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports